import { render, staticRenderFns } from "./publishActivity.vue?vue&type=template&id=fceaca6e&scoped=true&"
import script from "./publishActivity.vue?vue&type=script&lang=js&"
export * from "./publishActivity.vue?vue&type=script&lang=js&"
import style0 from "./publishActivity.vue?vue&type=style&index=0&id=fceaca6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fceaca6e",
  null
  
)

export default component.exports